/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';
import { queryString } from '../../../utils/format';
let $ajax;

export const state = {
  pics: {},
};

export const mutations = {
  SET_PIC(state, newValue) {
    state.pics = newValue;
  },
};

export const actions = {
  async fetch({}, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/pendampingan-pa`,
    });

    return await $ajax.get('/', { params: payload.params });
  },

  async getDetail({}, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/pendampingan-pa`,
    });
    return await $ajax.get(`/${payload.id}`);
  },

  async getPic({ commit, state }, payload) {
    if (state.pics[`${payload.id}-${payload.sekolah_id}`]) {
      return state.pics[`${payload.id}-${payload.sekolah_id}`];
    }

    const url = `psp/gtk/pendampingan-pa/${payload.id}/pic/${payload.sekolah_id}`;
    const data = await http.get(url).then(({ data }) => data);

    let cache = {};
    cache[`${payload.id}-${payload.sekolah_id}`] = data;
    commit('SET_PIC', Object.assign({}, state.pics, cache));

    return state.pics[`${payload.id}-${payload.sekolah_id}`];
  },

  async getSekolah({}, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/pendampingan-pa/${payload.id}/sekolah`,
    });
    return await $ajax.get(`/`, { params: payload.params });
  },

  async getInstrument({}, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/pendampingan-pa/${payload.id}/sekolah/${payload.sekolah_id}`,
    });
    return await $ajax.get(`/`, { params: payload.params });
  },

  updatePendampingan({}, payload) {
    const url = `/psp/gtk/pendampingan-pa/${payload.id}/update`;
    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateLaporan({}, payload) {
    const forms = {
      FormIndividu: 'individu',
    };

    const url = `/psp/gtk/pendampingan-pa/${payload.id}/update-${forms[payload.form] ||
      (payload.dasarKe ? 'laporan-dasar' : 'laporan')}/${payload.sekolah_id}`;
    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateSaran({}, payload) {
    const url = `/psp/gtk/pendampingan-pa/${payload.id}/update-laporan-saran/${payload.sekolah_id}`;
    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateSelesai({}, payload) {
    const url = `/psp/gtk/pendampingan-pa/${payload.id}/update-laporan-selesai/${payload.sekolah_id}`;
    return http.post(url, payload.params);
  },

  uploadBerkas({}, payload) {
    let url = `/psp/gtk/pendampingan-pa/${payload.pendampingId}/berkas-${payload.tipe}/${payload.sekolahId}/insert`;
    if (payload.berkasId) {
      url = `/psp/gtk/pendampingan-pa/${payload.pendampingId}/berkas-${payload.tipe}/${payload.sekolahId}/${payload.berkasId}/reupload`;
    }

    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateTerlaksana({}, payload) {
    const url = `/psp/gtk/pendampingan-pa/${payload.id}/update-laporan-terlaksana/${payload.sekolah_id}`;
    return http.post(url, payload.params);
  },

  action({}, payload) {
    const url = `/psp/gtk/pendampingan-pa/${payload.pendampingId}/berkas-${payload.tipe}/${payload.sekolahId}/${payload.id}/${payload.action}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  cekRekaman({}, payload) {
    return http.get(`/psp/gtk/pendampingan-pa/cek-rekaman?${queryString(payload)}`).then(({ data }) => data);
  },
};
